import { render } from "./InfoAnimationDown.vue?vue&type=template&id=2fa13938"
import script from "./InfoAnimationDown.vue?vue&type=script&lang=js"
export * from "./InfoAnimationDown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__